import { useLocation } from "react-router-dom";
import NotFound from "../common/not-found";
import '../../sass/database.scss';
import { Pagination } from "@mui/material";
import PostBrief from "../common/post-brief";
import SubSection from "../common/sub-section";
import {getAllPost, getImageUrl, getSections} from "../../utils/post-utils";
import {Post, Section as SectionType} from "../../common/types/post.types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loading from "../common/loading";
import {LIMIT_POSTS_SECTION} from "../../common/constants/post.const";

function Section() {
  const location = useLocation();
  const sections = useSelector((state: any) => state.sections.data);
  const [posts, setPosts] = useState<Post[]>([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [sectionData, setSectionData] = useState<SectionType>(null);
  const [loading, setLoading] = useState(false);

  const sectionPaths = location.pathname.split('/');
  // Remove first and second element is the empty string and the indicator of large component
  sectionPaths.shift();
  sectionPaths.shift();

  useEffect(() => {
    setSectionData(getSections([...sectionPaths], sections));
  }, [sectionPaths, sections])

  useEffect(() => {
    setLoading(true);
    getAllPost({page, limit: LIMIT_POSTS_SECTION}, sectionPaths).then(data => {
      if (!data) {
        return;
      }

      setPage(data.page);
      setTotal(data.total);
      setPosts(data.data);
      setLoading(false);
    })
  }, [page, location.pathname]);

  if (!sectionData) {
    return <NotFound />
  }

  const subSections = sectionData?.sub_sections?.map((item: any, index: number) => {
    return <SubSection path={`${location.pathname}/${item.path}`} name={item.name} image={getImageUrl(item.icon)} key={index}/>;
  })

  const postBriefs = posts.map((post: Post, index) => <PostBrief key={index} post={post} currentSectionTree={sectionPaths}/>)

  return (
    <div className={'database'}>
      <div className={'sub-sections'}>
        {subSections}
      </div>
      <div className={'posts'}>
        <div className={'list-post'}>
          {loading ? <Loading h={300}/> : postBriefs}
        </div>
        {total !== 0 && <Pagination count={Math.ceil(total / LIMIT_POSTS_SECTION)} hidden={total !== 0} showFirstButton showLastButton/>}
      </div>
    </div>
  )
}

export default Section;
